import React, {Component} from 'react';
import Title from '../base/title';
import api from '../../utils/api';

let toFloat = (number) => {
  return number ? parseFloat(number) : parseFloat(0);
};

export default class PricesStation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      opened: true,
      strategy: {}
    }
    this.goToSimulador = this.goToSimulador.bind(this);
  }

  componentDidMount() {
    let _self = this;
    let strategy = {};
    api.get('filters/products').then(resp => {
      resp.data.forEach(prod => {
        strategy[prod.short_name] = {}
      });
      api.get('widgets/actual-prices/?type=STATION&id=' + this.props.id).then(resp => {
        resp.data.forEach((price, index) => {
          let key = Object.keys(strategy)[index];
          if (!strategy[key]) strategy[key] = {}
          strategy[key].pra = toFloat(price.pvp).toFixed(2);
          strategy[key].last = toFloat(price.last_raise).toFixed(2);
          strategy[key].last_pos = price.last_raise >= 0 ? 'up' : 'down';
          strategy[key].date = price.date;
        })
        _self.setState({strategy: strategy});
      });
    });
  }

  goToSimulador() {
    window.location = '/simulador';
  }

  render() {
    let _self = this;
    return <div className="row">
        <Title isOpen={_self.state.opened} toggle={() => { _self.setState({ strategy: {}, opened: !_self.state.opened }, function() { if (_self.state.opened) _self.componentDidMount(); }); }} edit={ {onClick: this.goToSimulador, icon: 'fas fa-arrow-right', label: 'SIMULAR PRECIOS'} } text="PRECIOS ACTUALES" isGray={true} hasIcon={true} />
        {this.state.opened && <div className="row">
          <div className="col s12">
            <div className="row">
              <div className="marketShare">
                <table className='c-table'>
                  <thead>
                    <tr>
                      <td>&nbsp;</td>
                      {Object.keys(_self.state.strategy).map((key) =>
                        <td key={key}>{key}</td>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Precio Actual ($)</td>
                      {Object.keys(_self.state.strategy).map((key) =>
                        <td key={key}><b>{_self.state.strategy[key].pra}</b></td>
                      )}
                    </tr>
                    <tr>
                      <td>Último aumento (%)</td>
                      {Object.keys(_self.state.strategy).map((key) =>
                        <td key={key}><i className={'fas fa-caret-' + _self.state.strategy[key].last_pos}></i>&nbsp;&nbsp;{_self.state.strategy[key].last}</td>
                      )}
                    </tr>
                    <tr>
                      <td>Fecha</td>
                      {Object.keys(_self.state.strategy).map((key) =>
                        <td key={key}>{_self.state.strategy[key].date}</td>
                      )}
                    </tr>
                  </tbody>
                  </table>
              </div>
            </div>
          </div>
        </div>}
      </div>
  }

}


// WEBPACK FOOTER //
// ./src/containers/analisis/pricesstation.js